import ApplicationLayout from '../../../components/layouts/ApplicationLayout';
import {
  getWinLossOverallPlatform,
  // getWinLostOverallOfPlatform,
  // getWinLostByProvider,
  getWinLossByProvider,
} from '../../../api/cms/summary';
import { LoadingBox } from '../../../components/LoadingBox';
import useSWR from 'swr';
import { Paper, Typography, Box, Grid } from '@material-ui/core';
import { toast } from 'react-toastify';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { Link, useParams, useLocation, useHistory } from 'react-router-dom';
import Breadcrumbs from '../../../components/Breadcrumbs';
import { modifyArray } from '../../../utils/array';
import { genParamsQueryFromDateRange, useDateRange } from '../../../utils/datetime';
import React from 'react';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableFooter,
  TablePagination,
} from '@material-ui/core';
import Thead from '../../../components/table/Thead';
import TablePaginationActions from '../../../components/table/TablePaginationActions';
import RoyaltyFeeGroup from '../../../components/summary/RoyaltyFeeGroup';
import {
  providerTableHead as tableHead,
  headGroupTable,
  overAllTableHead,
  overAllHeadGroupTable,
  headPlaformGroupTable,
  platformTableHead,
} from '../../../components/summary/thead-data';
import queryString from 'query-string';
import SummaryDateRangeContent from '../../../components/summary/SummaryDateRangeContent';

const PlatformDetail = () => {
  let { platformId } = useParams();
  let location = useLocation();
  const { search } = useLocation();
  const history = useHistory();
  let preventUrl = location.pathname
    .split('/')
    .filter((x) => x)
    .slice(0, 3)
    .join('/');

  const paramsString = queryString.parse(search);

  const [dateRange, setDateRange] = useDateRange(paramsString);

  const searchParam = React.useMemo(() => {
    return genParamsQueryFromDateRange(dateRange);
  }, [dateRange]);

  const onChangeDateRange = (range) => {
    setDateRange(range);
    const newSearchUrl = genParamsQueryFromDateRange(range);
    history.replace({
      pathname: '',
      search: `?${newSearchUrl}`,
      state: { isActive: true },
    });
  };

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);

  // getWinLostOverallOfPlatform({
  const { data, error } = useSWR(
    ['overAll', platformId, dateRange],
    () =>
      getWinLossOverallPlatform({
        platform_code: platformId,
        from_time: dateRange.startDateValue,
        to_time: dateRange.endDateValue,
      }),
    { revalidateOnFocus: false },
  );

  // getWinLostByProvider({
  const { data: dataDetail = {}, error: errorDetail } = useSWR(
    ['getProviderByPlatform', page, rowsPerPage, platformId, dateRange],
    (url, page, limit, platformId) =>
      getWinLossByProvider({
        page: page + 1,
        limit,
        platform_code: platformId,
        from_time: dateRange.startDateValue,
        to_time: dateRange.endDateValue,
      }),
    { revalidateOnFocus: false },
  );

  console.log('getWinLossOverallPlatform: ', data);
  console.log('getProviderByPlatform: ', dataDetail);

  const dataOverAllArr = data ? data : [];
  console.log('dataOverAllArr: ', dataOverAllArr);
  const { logs = [], total = 0 } = dataDetail || {};

  if (error || errorDetail) toast.error('error');

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const overAllGroupTable = React.useMemo(() => {
    if (!data) return overAllHeadGroupTable;
    return modifyArray(overAllHeadGroupTable, [
      { index: 1, name: `Platform (${data?.platform_name})` },
    ]);
  }, [data]);

  const headGroupTableModify = React.useMemo(() => {
    if (!data) return headPlaformGroupTable;
    return modifyArray(headPlaformGroupTable, [
      { index: 2, name: `Platform (${data?.platform_name})` },
    ]);
  }, [data]);

  // console.log('data', dataDetail);
  return (
    <ApplicationLayout>
      <Breadcrumbs
        keepSearchParams
        breadcrumbNameAddOn={{
          [`${location.pathname}`]: `${data?.platform_name || ''} (Platform)`,
        }}
      />
      <SummaryDateRangeContent
        onChange={onChangeDateRange}
        defaultValue={dateRange}
        value={dateRange}
      />
      {!dataOverAllArr ? (
        <LoadingBox />
      ) : (
        <>
          <Box my={2}>
            <Typography variant="h6" gutterBottom component="div">
              {`${data?.platform_name | ''}'s Overall`}
            </Typography>
            <TableContainer component={Paper}>
              <Table aria-label="win lost table" size="small">
                <Thead heads={overAllGroupTable} align="center" />
                <Thead heads={overAllTableHead} align="center" />
                <TableBody>
                  {dataOverAllArr.map((row, index) => (
                    <TableRow key={index}>
                      <RoyaltyFeeGroup data={row} />
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </>
      )}
      {!logs ? (
        <LoadingBox />
      ) : (
        <>
          <Typography variant="h6" gutterBottom component="div">
            Provider's Win/Lose
          </Typography>
          <TableContainer component={Paper}>
            <Table aria-label="win lost table">
              <Thead heads={headGroupTableModify} align="center" />
              <Thead heads={platformTableHead} align="center" />
              <TableBody>
                {logs.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align="center">
                      <Link to={`${platformId}/provider/${row.provider_code}/user?${searchParam}`}>
                        {row.provider_name}
                      </Link>
                    </TableCell>
                    <RoyaltyFeeGroup data={row} />
                  </TableRow>
                ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TableCell align="center">รวม</TableCell>
                  <RoyaltyFeeGroup data={dataOverAllArr?.[0] || []} disabledBg />
                </TableRow>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[25, 50, 100, { label: 'All', value: -1 }]}
                    colSpan={9}
                    count={total}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    SelectProps={{
                      inputProps: { 'aria-label': 'rows per page' },
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </>
      )}
    </ApplicationLayout>
  );
};

export default PlatformDetail;
